import { createListenerMiddleware } from '@reduxjs/toolkit';
import { inIframe } from '@appblocks/frontend/client/utils';
import { getWorkspaces } from '@appblocks/frontend/redux/workspacesSlice';


const axios = require('axios');

const workspaceMiddlware = createListenerMiddleware();
workspaceMiddlware.startListening({
    actionCreator: getWorkspaces,
    effect: async (action, store) => {
        try {
            if (inIframe()) {
                store.dispatch({
                    type: 'workspaces/setWorkspaces',
                    payload: [],
                });
                return;
            }
            const workspaces = await new Promise((resolve, reject) => {
                axios.get(`${process.env.API_URL}/api/workspaces/`, {
                    withCredentials: true,
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((e) => {
                        reject();
                    });
            });
            const { currentWorkspace } = store.getState().workspaces;
            if (currentWorkspace !== '') {
                let found = false;
                for (let i = 0; i < workspaces.length; i++) {
                    if (workspaces[i]._id === currentWorkspace) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    store.dispatch({
                        type: 'workspaces/setCurrentWorkspace',
                        payload: '',
                    });
                }
            }
            store.dispatch({
                type: 'workspaces/setWorkspaces',
                payload: workspaces,
            });
        } catch (e) {
            store.dispatch({
                type: 'workspaces/setWorkspaces',
                payload: [],
            });
        } finally {
            // store.dispatch({
            //     type: 'user/setLoaded',
            //     payload: true,
            // });
        }
    },
});

export default workspaceMiddlware;
